import React from 'react';
import styled from 'styled-components';
import { FiCheckCircle } from 'react-icons/fi';
import { semanticColors } from '@/common/styles/colorTokens';
import { typography } from '@/common/styles/typographyTokens';
import { Button } from '@/common/components/button/Button';

interface CompletionStepProps {
  onGoToLogin: () => void;
}

/**
 * 완료 단계 컴포넌트
 * 비밀번호 변경 성공 후 표시
 */
const CompletionStep: React.FC<CompletionStepProps> = ({ onGoToLogin }) => {
  return (
    <Container>
      <IconWrapper>
        <FiCheckCircle size={48} />
      </IconWrapper>
      
      <TextContainer>
        <Title>비밀번호 변경 완료</Title>
        <Message>
          비밀번호가 성공적으로 변경되었습니다.
          <br />
          새로운 비밀번호로 로그인해 주세요.
        </Message>
      </TextContainer>

      <SuccessAnimation>
        <SuccessIcon>🎉</SuccessIcon>
      </SuccessAnimation>

      <Button 
        $variant="gradient" 
        $size="md" 
        $isFull 
        onClick={onGoToLogin}
      >
        로그인 페이지로 이동
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px 0;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(34, 197, 94, 0.2) 100%);
  color: #10b981;
  animation: scaleIn 0.5s ease-out;
  
  @keyframes scaleIn {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
`;

const Title = styled.h2`
  ${typography.heading.h3}
  color: ${semanticColors.text.primary};
  margin: 0;
`;

const Message = styled.p`
  ${typography.paragraph.p1.default}
  color: ${semanticColors.text.secondary};
  margin: 0;
  line-height: 1.6;
`;

const SuccessAnimation = styled.div`
  display: flex;
  justify-content: center;
  animation: bounce 1s ease-in-out infinite;
  
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
`;

const SuccessIcon = styled.span`
  font-size: 32px;
`;

export default CompletionStep;
